import { withDependencies } from '@wix/thunderbolt-ioc'
import type { ModuleLoader } from '@wix/thunderbolt-renderer-utils'
import { ESMLoadRegistrarSymbol, ImportMapSymbol } from './symbols'
import type { ESMLoaderFactory, ESMLoadRegistrar, ImportMap } from './types'

export const ESMLoaderFactoryFactory = withDependencies(
	[ESMLoadRegistrarSymbol, ImportMapSymbol],
	(esmLoadRegistrar: ESMLoadRegistrar, importMap: ImportMap): ESMLoaderFactory => {
		let moduleLoader: ModuleLoader | null = null

		return ({ scriptsCache, defaultDependencies = {} }) => {
			if (Object.keys(defaultDependencies).length > 0) {
				importMap.updateImportMap(defaultDependencies as Record<string, string>)
			}

			if (!moduleLoader) {
				moduleLoader = {
					prefetchScript: (_url) => {
						// not implemented for esm
					},
					loadModule: async (url) => {
						importMap.createImportMap()

						const cached = scriptsCache[url]
						if (cached) {
							return cached
						}

						return esmLoadRegistrar.loadModuleWithCache(url, async () => {
							const module = await import(/* webpackIgnore: true */ url)
							scriptsCache[url] = module
							return module
						})
					}
				}
			}
			return moduleLoader
		}
	}
)
